import common from "@/assets/js/common";

const getters ={
    visitedViews:state => state.tags.visitedViews,
    activeIndex:state => state.tags.activeIndex,


    getKeepAlive:state => state.tags.keepAlive,

    getMenuList:state=>{
        if(state.menu.menuList.length===0){
            state.menu.menuList = JSON.parse(localStorage.getItem("m"));
        }
        return state.menu.menuList;
    },
    getPermissions:state=>{
        if(state.menu.permissions.length===0){
            let permission_list = localStorage.getItem("permission_list");
            if (permission_list!= null && permission_list.length>0){
                state.menu.permissions = JSON.parse(permission_list);
            }

        }
        return state.menu.permissions;
    },

    getToken(state){
        if(state.user.token===""||state.user.token==null||!state.user.token){
            state.user.token = common.getCookie("token");
        }
        return state.user.token;
    },



};

export default getters
